"use client";

import { LastTradesTable } from "#/components/LastTradesTable/LastTradesTable";
import { useLastOptionTradesByInstrument } from "#/hooks/useLastOptionTradesByInstrument";

export const OptionsLastTrades = () => {
  const { lastTrades, isLoading, underlying } =
    useLastOptionTradesByInstrument();

  return (
    <LastTradesTable
      variant="options"
      isLoading={isLoading}
      lastTrades={lastTrades}
      underlying={underlying}
    />
  );
};
